(() => {
  const initSourceVariants = page => {
    page.querySelectorAll('[data-pdp-shopify-product]').forEach(config => {
      if (config.dataset.ready) return;
      let data; try { data = JSON.parse(config.textContent); } catch { return; }
      if (!Array.isArray(data.variants) || !data.variants.length) return;
      const root = page.querySelector('[data-fast51-dynamic-commerce]');
      const form = root?.querySelector('.fast51-product-form');
      const radios = [...root?.querySelectorAll('.simple-variant-picker input[type="radio"]') || []];
      if (!form || !radios.length) return;
      config.dataset.ready = 'true';
      const money = amount => new Intl.NumberFormat('en-US', { style: 'currency', currency: data.currency || 'USD' }).format(Number(amount) / 100);
      const synchronize = (showImage = false, forced = null) => {
        const values = data.options.map((name, index) => radios.find(input => input.checked && Number(input.dataset.optionPosition) === index + 1)?.value);
        const variant = forced || data.variants.find(variant => variant.options.every((value, index) => value === values[index]));
        const id = form.querySelector('[name="id"]');
        const submit = form.querySelector('[name="add"]');
        if (id) id.value = variant?.id || '';
        if (submit) submit.disabled = !variant || variant.available === false;
        if (!variant) return;
        if (forced) radios.forEach(input => { input.checked = variant.options[Number(input.dataset.optionPosition) - 1] === input.value; });
        root.querySelectorAll('.simple-variant-picker__option').forEach(option => {
          const label = option.querySelector('.simple-variant-picker__selected-value');
          const input = option.querySelector('input:checked');
          if (label && input) label.textContent = input.value;
        });
        const price = root.querySelector('[data-fast51-dynamic-price]');
        const sale = Number(variant.compare_at_price) > Number(variant.price);
        if (price) {
          price.dataset.fast51OnSale = String(sale);
          price.querySelectorAll('.shop-product-price-block,.price-item--sale,.price__regular .price-item--regular').forEach(node => node.textContent = money(variant.price));
          price.querySelectorAll('.shop-compare-price,.price__compare-price s').forEach(node => node.textContent = money(variant.compare_at_price || 0));
          price.querySelectorAll('.shop-save-price,.badge__percentage-saved').forEach(node => node.textContent = sale ? Math.round(100 * (1 - variant.price / variant.compare_at_price)) + '%' : '');
        }
        if (showImage) {
          const index = variant.media_index ?? data.media_ids?.findIndex(id => String(id) === String(variant.featured_media?.id));
          const gallery = root.querySelector('[data-pdp-gallery]');
          const slide = [...gallery?.querySelectorAll('[data-pdp-gallery-slide]') || []][index];
          if (slide) {
            slide.hidden = false;
            const thumb = [...gallery.querySelectorAll('[data-pdp-gallery-thumb]')].find(node => Number(node.dataset.pdpGalleryThumb) === index);
            if (thumb) { thumb.hidden = false; thumb.classList.remove('visually-hidden'); thumb.click(); }
          }
        }
      };
      radios.forEach(input => input.addEventListener('change', () => synchronize(input.closest('.option--color') != null)));
      const explicit = new URL(location.href).searchParams.get('variant');
      synchronize(Boolean(explicit), data.variants.find(variant => String(variant.id) === explicit));
      // Shopify's hidden input named "id" shadows HTMLFormElement.id.
      const formId = form.getAttribute('id');
      if (formId) root.querySelectorAll('[data-fourpaw-personalization-role] input').forEach(input => input.setAttribute('form', formId));
    });
  };

  const initGallery = (page) => {
    page.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.pdpSkillReady === 'true') return;
      const list = gallery.querySelector('.product__media-list');
      const slides = [...gallery.querySelectorAll('.product__media-item')];
      const thumbs = [...gallery.querySelectorAll('.thumbnail, [data-pdp-gallery-thumb]')];
      const mainPrevious = gallery.querySelector('.product-media-slider [name="previous"], [data-pdp-gallery-previous]');
      const mainNext = gallery.querySelector('.product-media-slider [name="next"], [data-pdp-gallery-next]');
      const thumbnailSlider = gallery.querySelector('.thumbnail-slider');
      const thumbnailList = thumbnailSlider?.querySelector('.thumbnail-list');
      const thumbnailItems = thumbnailList ? [...thumbnailList.children] : [];
      const thumbnailPrevious = thumbnailSlider?.querySelector('[name="previous"]');
      const thumbnailNext = thumbnailSlider?.querySelector('[name="next"]');
      if (!list || slides.length < 2) return;
      gallery.dataset.pdpSkillReady = 'true';
      let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let scrollFrame = 0;
      const thumbIndex = (thumb, fallbackIndex) => {
        const owner = thumb.closest('[data-target], [data-media-position]');
        const target = owner?.dataset.target || thumb.dataset.target || '';
        const position = Number(owner?.dataset.mediaPosition || thumb.dataset.mediaPosition || 0);
        const targetIndex = target ? slides.findIndex((slide) => slide.dataset.mediaId === target || slide.id === target || slide.id.endsWith(target)) : -1;
        if (targetIndex >= 0) return targetIndex;
        if (position > 0 && position <= slides.length) return position - 1;
        return fallbackIndex;
      };
      const show = (nextIndex, { smooth = true, scroll = true } = {}) => {
        current = Math.max(0, Math.min(slides.length - 1, nextIndex));
        gallery.dataset.pdpSkillIndex = String(current);
        slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === current);
          if (index === current) slide.setAttribute('aria-current', 'true');
          else slide.removeAttribute('aria-current');
        });
        thumbs.forEach((thumb, index) => {
          if (thumbIndex(thumb, index) === current) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        if (scroll) {
          const left = slides[current].offsetLeft;
          if (typeof list.scrollTo === 'function') list.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
          else list.scrollLeft = left;
        }
        if (mainPrevious) mainPrevious.disabled = current === 0;
        if (mainNext) mainNext.disabled = current === slides.length - 1;
        const activeThumb = thumbs.find((thumb, index) => thumbIndex(thumb, index) === current);
        const activeThumbItem = activeThumb?.closest('li') || activeThumb;
        if (thumbnailList && activeThumbItem) {
          const itemStart = activeThumbItem.offsetLeft;
          const itemEnd = itemStart + activeThumbItem.offsetWidth;
          const visibleStart = thumbnailList.scrollLeft;
          const visibleEnd = visibleStart + thumbnailList.clientWidth;
          if (itemStart < visibleStart || itemEnd > visibleEnd) {
            const left = Math.max(0, itemStart - Math.max(0, (thumbnailList.clientWidth - activeThumbItem.offsetWidth) / 2));
            if (typeof thumbnailList.scrollTo === 'function') thumbnailList.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
            else thumbnailList.scrollLeft = left;
          }
        }
      };
      const syncFromScroll = () => {
        scrollFrame = 0;
        const index = slides.reduce((best, slide, slideIndex) => (
          Math.abs(slide.offsetLeft - list.scrollLeft) < Math.abs(slides[best].offsetLeft - list.scrollLeft) ? slideIndex : best
        ), 0);
        if (index !== current) show(index, { smooth: false, scroll: false });
      };
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(thumbIndex(thumb, index))));
      mainPrevious?.addEventListener('click', () => show(current - 1));
      mainNext?.addEventListener('click', () => show(current + 1));
      list.addEventListener('scroll', () => {
        if (!scrollFrame) scrollFrame = requestAnimationFrame(syncFromScroll);
      }, { passive: true });
      list.addEventListener('scrollend', syncFromScroll);
      if (thumbnailList && thumbnailItems.length > 1 && (thumbnailPrevious || thumbnailNext)) {
        let thumbnailFrame = 0;
        const updateThumbnailButtons = () => {
          thumbnailFrame = 0;
          const max = Math.max(0, thumbnailList.scrollWidth - thumbnailList.clientWidth);
          if (thumbnailPrevious) thumbnailPrevious.disabled = thumbnailList.scrollLeft <= 1;
          if (thumbnailNext) thumbnailNext.disabled = thumbnailList.scrollLeft >= max - 1;
        };
        const thumbnailStride = () => {
          if (thumbnailItems.length > 1) return Math.max(1, thumbnailItems[1].offsetLeft - thumbnailItems[0].offsetLeft);
          return Math.max(1, thumbnailItems[0]?.offsetWidth || thumbnailList.clientWidth);
        };
        const pageThumbnails = (direction, control) => {
          const step = Math.max(1, Number(control?.dataset.step || 0) || 3);
          const max = Math.max(0, thumbnailList.scrollWidth - thumbnailList.clientWidth);
          const left = Math.max(0, Math.min(max, thumbnailList.scrollLeft + direction * thumbnailStride() * step));
          if (typeof thumbnailList.scrollTo === 'function') thumbnailList.scrollTo({ left, behavior: 'smooth' });
          else thumbnailList.scrollLeft = left;
        };
        thumbnailPrevious?.addEventListener('click', () => pageThumbnails(-1, thumbnailPrevious));
        thumbnailNext?.addEventListener('click', () => pageThumbnails(1, thumbnailNext));
        thumbnailList.addEventListener('scroll', () => {
          if (!thumbnailFrame) thumbnailFrame = requestAnimationFrame(updateThumbnailButtons);
        }, { passive: true });
        thumbnailList.addEventListener('scrollend', updateThumbnailButtons);
        updateThumbnailButtons();
      }
      show(current, { smooth: false, scroll: false });
    });
  };

  const initBundleSelectors = (page) => {
    page.querySelectorAll('.kaching-bundles, [data-bundle-selector]').forEach((bundle) => {
      if (bundle.dataset.pdpSkillReady === 'true') return;
      const bars = [...bundle.querySelectorAll('.kaching-bundles__bar, [data-bundle-option]')];
      if (!bars.length) return;
      bundle.dataset.pdpSkillReady = 'true';
      const select = (bar) => {
        bars.forEach((candidate) => candidate.classList.toggle('kaching-bundles__bar--selected', candidate === bar));
        const input = bar.querySelector('input[type="radio"]');
        if (input) input.checked = true;
      };
      select(bars.find((bar) => bar.classList.contains('kaching-bundles__bar--selected')) || bars[0]);
      bars.forEach((bar) => {
        bar.querySelector('input[type="radio"]')?.addEventListener('change', () => select(bar));
        bar.querySelector('[role="button"]')?.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          bar.querySelector('input[type="radio"]')?.click();
        });
      });
    });
  };

  const initCarousels = (page) => {
    page.querySelectorAll('splide-component').forEach((component) => {
      const root = component.querySelector('.splide');
      const list = component.querySelector('.splide__list');
      const slides = [...component.querySelectorAll('.splide__slide')];
      const pagination = component.querySelector('.splide__pagination');
      const arrows = component.querySelector('.splide__arrows');
      if (!root || !list || !pagination || !arrows || slides.length < 2 || root.dataset.pdpSkillReady === 'true') return;
      root.dataset.pdpSkillReady = 'true';
      root.classList.add('is-initialized', 'pdp-skill-carousel-ready');
      pagination.replaceChildren();
      arrows.replaceChildren();
      let current = 0;
      const show = (nextIndex) => {
        current = Math.max(0, Math.min(slides.length - 1, nextIndex));
        const mobile = matchMedia('(max-width: 749px)').matches;
        list.style.transform = mobile ? `translate3d(${-current * 100}%,0,0)` : '';
        slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === current);
          if (mobile) slide.setAttribute('aria-hidden', String(index !== current));
          else slide.removeAttribute('aria-hidden');
        });
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === current);
          if (index === current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        previous.disabled = current === 0;
        next.disabled = current === slides.length - 1;
      };
      const dots = slides.map((_, index) => {
        const item = document.createElement('li');
        item.setAttribute('role', 'presentation');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'splide__pagination__page';
        button.setAttribute('aria-label', `Go to slide ${index + 1}`);
        button.addEventListener('click', () => show(index));
        item.append(button);
        pagination.append(item);
        return button;
      });
      const previous = document.createElement('button');
      previous.type = 'button';
      previous.className = 'splide__arrow splide__arrow--prev';
      previous.setAttribute('aria-label', 'Previous slide');
      previous.textContent = '‹';
      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'splide__arrow splide__arrow--next';
      next.setAttribute('aria-label', 'Next slide');
      next.textContent = '›';
      arrows.append(previous, next);
      previous.addEventListener('click', () => show(current - 1));
      next.addEventListener('click', () => show(current + 1));
      matchMedia('(max-width: 749px)').addEventListener?.('change', () => show(current));
      show(0);
    });
  };

  const initDailyCountdowns = (page) => {
    page.querySelectorAll('.coco-promo__timer, [data-pdp-skill-daily-countdown]').forEach(timer => {
      if (timer.dataset.pdpSkillCountdownReady === 'true') return;
      const timeZone = timer.dataset.pdpSkillCountdownZone || 'America/New_York';
      const clock = new Intl.DateTimeFormat('en-GB', {
        timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      });
      const wallTime = date => {
        const parts = Object.fromEntries(clock.formatToParts(date).map(part => [part.type, part.value]));
        return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day),
          Number(parts.hour), Number(parts.minute), Number(parts.second));
      };
      let currentDay = -1;
      let midnight = 0;
      const render = () => {
        const now = Date.now();
        const wall = wallTime(new Date(now));
        const day = Math.floor(wall / 86400000);
        if (day !== currentDay) {
          currentDay = day;
          const nextWallMidnight = (day + 1) * 86400000;
          midnight = nextWallMidnight;
          // Resolve the next local midnight's UTC offset, including DST changes.
          for (let i = 0; i < 3; i++) midnight += nextWallMidnight - wallTime(new Date(midnight));
        }
        const seconds = Math.max(0, Math.ceil((midnight - now) / 1000));
        timer.textContent = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60]
          .map(value => String(value).padStart(2, '0')).join(':');
        timer.dataset.pdpSkillCountdownZone = timeZone;
      };
      timer.dataset.pdpSkillCountdownReady = 'true';
      render();
      const interval = setInterval(() => {
        if (!timer.isConnected) { clearInterval(interval); return; }
        render();
      }, 1000);
    });
  };

  const initDestinationBundles = (page) => {
    page.querySelectorAll('[id^="ProductInfo-"]').forEach(info => {
      if (info.dataset.pdpSkillDestinationBundleReady === 'true') return;
      const captured = [...info.querySelectorAll('[class*="rapi-bundle-content-"]')];
      if (!captured.length) return;
      info.dataset.pdpSkillDestinationBundleReady = 'true';
      const reconcile = () => {
        // The destination app owns current prices, variants, discounts and gifts.
        // Keep the reference offer for isolated previews until a real app renders.
        const app = [...info.querySelectorAll('.kaching-bundles')]
          .find(bundle => !captured.some(snapshot => snapshot.contains(bundle))
            && bundle.querySelector('.kaching-bundles__bar'));
        if (!app) return false;
        captured.forEach(snapshot => snapshot.remove());
        return true;
      };
      if (reconcile()) return;
      const observer = new MutationObserver(() => {
        if (!info.isConnected || reconcile()) observer.disconnect();
      });
      observer.observe(info, { childList: true, subtree: true });
    });
  };

  const init = () => {
    const page = document.querySelector('#MainContent') || document;
    initGallery(page);
    initBundleSelectors(page);
    initCarousels(page);
    initDailyCountdowns(page);
    initDestinationBundles(page);
    initSourceVariants(page);
    page.querySelectorAll('video[data-fast51-content-video]').forEach(video => {
      if (!video.autoplay) return;
      video.muted = true;
      video.playsInline = true;
      if (video.loop) {
        video.controls = false;
        const host = video.closest('[data-autoplay-blocked]') || video.parentElement;
        host?.removeAttribute('data-autoplay-blocked');
        host?.querySelectorAll('.custom-benefit-video-play, .custom-video-play, [data-video-play], .video-play-button, .custom-video-play-button').forEach(button => button.remove());
      }
      const play = () => video.play().catch(() => {});
      play();
      if (!video.dataset.pdpAutoplayReady) {
        video.dataset.pdpAutoplayReady = 'true';
        video.addEventListener('loadeddata', play);
        new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) play(); }).observe(video);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

(() => {
  const init = () => {
    const page = document.querySelector('#MainContent') || document;
    page.querySelectorAll('[data-pdp-associated-commerce]').forEach(config => {
      if (config.dataset.ready) return;
      let data, main;
      try {
        data = JSON.parse(config.textContent);
        main = JSON.parse(page.querySelector('[data-pdp-shopify-product]').textContent);
      } catch { return; }
      const root = page.querySelector('[data-fast51-dynamic-commerce]');
      const form = root?.querySelector('.fast51-product-form');
      const pack = root?.querySelector('fourpaw-package-selector');
      if (!form || !pack || !Array.isArray(data.offers)) return;
      config.dataset.ready = 'true';
      const currency = data.currency || main.currency || 'USD';
      const money = amount => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(Number(amount) / 100);
      const selectedMain = () => main.variants.find(variant => String(variant.id) === form.querySelector('[name="id"]')?.value);
      const match = offer => {
        const selected = selectedMain();
        if (!selected || !offer.product) return null;
        return offer.product.variants?.find(variant => variant.available !== false && offer.product.options.every((option, index) => {
          const name = typeof option === 'string' ? option : option.name;
          const position = main.options.findIndex(mainOption => mainOption.toLowerCase() === name.toLowerCase());
          return position < 0 ? offer.product.variants.length === 1 : variant.options[index] === selected.options[position];
        }));
      };
      const message = document.createElement('p');
      message.className = 'pdp-package-message';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      message.hidden = true;
      form.append(message);
      const showMessage = text => { message.textContent = text; message.hidden = !text; };
      const synchronize = () => {
        data.offers.filter(offer => offer.role === 'upsell').forEach(offer => {
          const card = [...pack.querySelectorAll('[data-package-card]')].find(card => card.dataset.packageAddon === offer.key);
          const input = card?.querySelector('[data-package-input]');
          if (!input) return;
          const variant = match(offer);
          input.disabled = !variant;
          if (!variant) input.checked = false;
          input.setAttribute('aria-checked', String(input.checked));
          card.classList.toggle('is-selected', input.checked);
          const status = card.querySelector('[data-package-status]');
          if (status) { status.hidden = Boolean(variant); status.textContent = 'Matching variant unavailable'; }
          if (!variant) return;
          const update = (selector, text) => { const node = card.querySelector(selector); if (node) node.textContent = text; };
          update('[data-package-match]', variant.options.filter(value => value !== 'Default Title').join(' · '));
          // A browser cannot set line prices. Only show Shopify's actual price
          // until an independently verified discount integration is present.
          update('[data-package-addon-price]', money(variant.price));
          const compare = card.querySelector('[data-package-addon-compare]');
          const savings = card.querySelector('[data-package-addon-savings]');
          const sale = Number(variant.compare_at_price) > Number(variant.price);
          if (compare) { compare.hidden = !sale; compare.textContent = sale ? money(variant.compare_at_price) : ''; }
          if (savings) { savings.hidden = !sale; savings.textContent = sale ? `Save ${Math.round(100 * (1 - variant.price / variant.compare_at_price))}%` : ''; }
          const image = card.querySelector('[data-package-product-image]');
          const src = variant.featured_image?.src || variant.featured_image;
          if (image && typeof src === 'string' && src) { image.removeAttribute('srcset'); image.src = src; image.alt = offer.product.title; }
          const info = card.querySelector('[data-package-info-button]');
          const panel = [...pack.querySelectorAll('[data-pdp-dialog-state-item]')].find(panel => panel.dataset.pdpDialogStateItem === info?.dataset.pdpDialogState);
          if (panel) {
            const amount = panel.querySelector('[data-package-info-bundle]');
            const original = panel.querySelector('[data-package-info-standalone]');
            if (amount) { amount.textContent = money(variant.price); if (amount.previousElementSibling) amount.previousElementSibling.textContent = 'Current price'; }
            if (original) { original.hidden = !sale; original.textContent = sale ? money(variant.compare_at_price) : ''; if (original.previousElementSibling) { original.previousElementSibling.textContent = 'Compare-at price'; original.previousElementSibling.hidden = !sale; } }
            const matchLabel = panel.querySelector('[data-package-info-match]');
            if (matchLabel) matchLabel.textContent = variant.options.filter(value => value !== 'Default Title').join(' · ');
            const detailImage = panel.querySelector('[data-package-info-image]');
            if (detailImage && typeof src === 'string' && src) { detailImage.removeAttribute('srcset'); detailImage.src = src; detailImage.alt = offer.product.title; }
            const note = panel.querySelector('.fourpaw-package__dialog-note');
            if (note) note.textContent = 'This matching add-on is added with your harness at the current price shown above.';
          }
        });
      };
      pack.querySelectorAll('[data-package-input]').forEach(input => input.addEventListener('change', synchronize));
      root.addEventListener('change', event => {
        if (event.target.matches('.simple-variant-picker input')) queueMicrotask(synchronize);
      });
      synchronize();
      let busy = false;
      form.addEventListener('submit', async event => {
        // Offline previews deliberately have no submit button. Never send their
        // saved fixture IDs to a storefront, including programmatic submits.
        if (!form.querySelector('button[type="submit"][name="add"]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (busy) return;
        synchronize();
        const variant = selectedMain();
        if (!variant || variant.available === false) return showMessage('Choose an available harness first.');
        const values = new FormData(form);
        const quantity = Math.max(1, Math.floor(Number(values.get('quantity')) || 1));
        const properties = {};
        for (const [name, value] of values) {
          const key = name.match(/^properties\[(.+)\]$/)?.[1];
          if (key && String(value).trim()) properties[key] = String(value);
        }
        const set = String(variant.id) + ':' + JSON.stringify(properties);
        const items = [{ id: variant.id, quantity, properties: { ...properties, '_PDP set': set } }];
        for (const offer of data.offers) {
          const input = [...pack.querySelectorAll('[data-package-input]')].find(input => input.value === offer.key);
          if (offer.role === 'upsell' && (!input?.checked || input.disabled)) continue;
          const linked = match(offer);
          if (!linked || (offer.role === 'gift' && Number(linked.price) !== 0)) {
            return showMessage(`${offer.product?.title || 'An included gift'} is unavailable. Please try again later.`);
          }
          items.push({ id: linked.id, quantity: quantity * offer.quantity, properties: offer.role === 'gift' ? { ...properties, '_Included gift': 'SafeWalk harness', '_PDP set': set, '_PDP gift units': String(offer.quantity) } : {} });
        }
        busy = true;
        const button = form.querySelector('[name="add"]');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        showMessage('');
        const cart = document.querySelector('[data-pdp-cart-drawer]') || document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const base = window.Shopify?.routes?.root || '/';
        const sections = cart?.getSectionsToRender?.().map(section => section.id).slice(0, 5) || ['cart-icon-bubble'];
        cart?.setActiveElement?.(button);
        try {
          const response = await fetch(base + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, sections, sections_url: location.pathname })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Your set could not be added. Please try again.');
          showMessage('');
          if (cart?.renderContents && result.sections && sections.every(id => result.sections[id])) {
            cart.classList.remove('is-empty');
            try { await cart.renderContents({ ...result, id: result.items?.[0]?.id || variant.id }); }
            catch { location.assign(base + 'cart'); }
          } else {
            // The purchase succeeded even if a theme cannot render its drawer.
            // Navigate to the real cart; do not retry and duplicate the items.
            location.assign(base + 'cart');
          }
        } catch (error) {
          showMessage(error.message || 'Your set could not be added. Please try again.');
        } finally {
          busy = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }, true);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
